import type { NDateLocale } from './enUS'
import { is } from 'date-fns/locale'

const dateIsIS: NDateLocale = {
  name: 'is-IS',
  locale: is
}

export default dateIsIS
